module.exports = __webpack_public_path__ + "static/media/importspeadseet.c4eb9c4b.svg";